import * as React from 'react';
import * as offer from "./style.module.scss";
export const OfferAdult = () => {
  return (
    <section className={offer.offer}>
      <div className="container">
        <div className={offer.offer__wrapper}>
          <div className={offer.offer__block}>
            <div className={offer.offer__subtitle}>Что даёт кураторское сопровождение?</div>
            <ul className={offer.offer__list1}>
              <li className={offer.offer__item}>помогает выстроить учебный процесс в&nbsp;повседневный график;</li>
              <li className={offer.offer__item}>формирует привычку заниматься регулярно;</li>
              <li className={offer.offer__item}>помогает отслеживать и&nbsp;своевременно корректировать неверное выполнение заданий.</li>
            </ul>
          </div>
          <div className={offer.offer__block}>
            <div className={offer.offer__subtitle}>Что вы получаете:</div>
            <ul className={offer.offer__list2}>
              <li className={offer.offer__item}>обратную связь и&nbsp;экспертную помощь в&nbsp;освоении навыков;</li>
              <li className={offer.offer__item}>дополнительные задания на&nbsp;закрепление и&nbsp;проверку;</li>
              <li className={offer.offer__item}>общение с&nbsp;другими участниками курса.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
